import { useContext } from 'react';
import { IKeyAnyValue } from 'common/types';
import { Modal, ModalFuncContext, ModalPosition } from 'contexts/modalFunc';
import { TripType, useSearchParamsContext } from 'contexts/searchParams';
import EverywhereCalendar from './everywhere';
import MultipleCalendar from './multiple';
import OneWayCalendar from './oneWay';
import RoundTripCalendar from './roundTrip';

const CalendarComponents: IKeyAnyValue = {
  [TripType.RT]: RoundTripCalendar,
  [TripType.OW]: OneWayCalendar,
  [TripType.MD]: MultipleCalendar,
  [TripType.EVERYWHERE]: EverywhereCalendar,
};

const FlightCalendar = ({ index = 0 }: { index?: number }) => {
  const {
    searchParams,
    isDomestic,
    setDepartureDate,
    setDepartureDates,
    setSearchParams,
    setStayLength,
  } = useSearchParamsContext();
  const setModal = useContext(ModalFuncContext);

  const closeModal = () =>
    setModal({ type: Modal.NULL, position: ModalPosition.MAIN });
  const { tripType } = searchParams;
  const Calendar = CalendarComponents[tripType];
  if (!Calendar) return null;

  return (
    <Calendar
      searchParams={searchParams}
      setDepartureDate={setDepartureDate}
      setDepartureDates={setDepartureDates}
      setSearchParams={setSearchParams}
      closeModal={closeModal}
      index={index}
      isDomestic={isDomestic}
      setStayLength={setStayLength}
    />
  );
};

export default FlightCalendar;
